/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Try_AgainInputs */

const en_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const ar_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة المحاولة`)
};

const bn_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আবার চেষ্টা করুন`)
};

const de_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const es_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentar de nuevo`)
};

const fr_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const pt_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

const zh_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再试一次`)
};

const tr_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar deneyin`)
};

const ru_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте еще раз`)
};

const pl_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spróbuj ponownie`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Error_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_try_again = /** @type {((inputs?: Error_Try_AgainInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Try_AgainInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_error_try_again(inputs)
	if (locale === "bn") return bn_error_try_again(inputs)
	if (locale === "de") return de_error_try_again(inputs)
	if (locale === "es") return es_error_try_again(inputs)
	if (locale === "fr") return fr_error_try_again(inputs)
	if (locale === "pt") return pt_error_try_again(inputs)
	if (locale === "zh") return zh_error_try_again(inputs)
	if (locale === "tr") return tr_error_try_again(inputs)
	if (locale === "ru") return ru_error_try_again(inputs)
	if (locale === "pl") return pl_error_try_again(inputs)
	return en_error_try_again(inputs)
});